/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcAssetsV1AssetExceptionEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_ASSETS_V1_ASSET_EXCEPTION_EVENT_ENTITY_NAME = 'ixc.assets.v1.AssetExceptionEvent';
export const ixcAssetsV1AssetExceptionEventEntity = new schema.Entity<IxcAssetsV1AssetExceptionEvent>(IXC_ASSETS_V1_ASSET_EXCEPTION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcAssetsV1AssetExceptionEvent) => `${entity.metadata?.eventId}` });

